import { Button, Popconfirm } from "antd";

export const getColumns = ({ rooms, handleDelete, handleEdit }) => {
  return [
    {
      title: "Rate Plan",
      dataIndex: "rateplanname",
      key: "rateplanname",
    },
    {
      title: "Selected Room(s)",
      dataIndex: "room",
      key: "room",
      render: (roomIds) => {
        const roomNames = roomIds
          .map((roomId) => {
            const room = rooms.find((r) => r._id === roomId);
            return room ? room.name : "";
          })
          .filter(Boolean)
          .join(", ");
        return roomNames || "No rooms selected";
      },
    },
    {
      title: "Cancellation Policy",
      dataIndex: "cancellationPolicy",
      key: "cancellationPolicy",
      render: (cancellationPolicy) => {
        if (!cancellationPolicy) return "No policy";
        const { chargeType, chargePercentage, daysBeforeCheckin } =
          cancellationPolicy;
        return `${chargeType} - ${chargePercentage}% charge if canceled ${daysBeforeCheckin} days before check-in.`;
      },
    },
    {
      title: "Meal Plan",
      dataIndex: "mealPlan",
      key: "mealPlan",
    },
    {
      title: "Rate Plan Setup",
      dataIndex: "ratePlanSetup",
      key: "ratePlanSetup",
    },
    {
      title: "Description",
      dataIndex: "ratePlanDescription",
      key: "ratePlanDescription",
      render: (description) => description || "No description provided",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <Button
            onClick={() => handleEdit(record)}
            type="primary"
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this rate plan?"
            onConfirm={() => handleDelete(record._id)}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
};
